<h3 mat-dialog-title>{{ 'Verify your Stripe account' }}</h3>
<img (click)="close()" class="mat-close" src="/assets/images/payhoa/other/icon_close.svg">

<mat-dialog-content>
    <ng-container *ngIf="loading$ | async">
        <app-empty-state [showSpinner]="true" [style.min-height.px]="400">
            <p emptyStateText>{{ 'Loading verification form...' }}</p>
        </app-empty-state>
    </ng-container>

    <div #stripeContainer
         class="stripe-container"
         [class.hidden]="loading$ | async">
    </div>
</mat-dialog-content>
